<template>
  <div :id="id" class="page">
    <div class="page-messages" v-if="messages && messages.length">
      <div class="page-message"
        v-for="(message, index) in messages"
        :key="index"
        :class="{
          'message': true,
          [message.type || 'error']: true,
        }">
        <p>{{message.text}}</p>
        <button type="button" class="message-close" @click="onClickCloseMessage(index)">
          <span class="message-close-icon"></span>
          <span class="message-close-text sr-only">Close</span>
        </button>
      </div>  
    </div>    
    <h1 class="page-header">{{header}}</h1>
    <slot></slot>
  </div>
</template>

<script>
import { mutations } from "@/store/types";

export default {
  name: "PageComponent",
  props: {
    id: String,
    header: String,
  },
  computed: {
    messages() {
      return this.$store.state.messages;
    }
  },
  methods: {
    onClickCloseMessage(index) {
      this.$store.commit(mutations.DELETE_MESSAGE, index);
    }
  }
}
</script>

<style lang="less">
.page-messages {
  padding: 12px 0;
  position: fixed;
  top: 60px;
  left: 12px;
  right: 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  z-index: 999;

  .page-message {
    box-shadow: 1px 6px 20px -6px rgba(0,0,0,0.25);
    margin: 0 auto;
    margin-bottom: 12px;
    width: 100%;
  }
}
</style>
